
import { Vue } from "vue-class-component";

export default class Rejected extends Vue {}
